import styled from '@emotion/styled';
import { Switch } from '@mui/material';

const StyledSwitchButton = styled(Switch)(({ theme, value }) => ({
    width: 52,
    height: 32,
    padding: theme.spacing(0),
    borderRadius: 20,
    border: '2px solid',
    borderColor: value === true ? theme.colors.primary : theme.colors.outline,
    '& .MuiSwitch-switchBase': {
        margin: theme.spacing(0.25),
        padding: 0,
        '&.Mui-checked': {
            width: 24,
            height: 24,
            backgroundColor: theme.colors.surface,
            color: theme.colors.onSurface,
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.colors.primary
            }
        },
        '& .MuiSvgIcon-root': {
            padding: '4px',
            backgroundColor: value === true ? theme.colors.surface : theme.colors.outline,
            borderRadius: 12
        }
    },
    '& .MuiSwitch-thumb': {
        width: 24,
        height: 24
    },
    '& .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.colors.surfaceVariant
    }
}));

export { StyledSwitchButton };
